import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {fetchProductHistory, onChangeFilter} from "../../store/product-slice";
import Pagination from "../../components/common/table/Pagination";
import moment from "moment-timezone";
import {getValidatedLimit} from "../../components/Utility";
import Stack from "../../components/ui/Stack";
import {ProductScope} from "../../enums/enums";

const timezone = 'Asia/Kolkata';
const ProductHistory = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {pagination, historyPagination, filter} = useSelector(state => state.product);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        productHistory: items,
        fetchHistoryStatus,
        error
    } = useSelector(state => state.product);

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    const handleChange = (key, value) => {
        dispatch(onChangeFilter({key, value}));
    };

    useEffect(() => {
        if (params.productId && filter.startDate && filter.endDate) {
            dispatch(fetchProductHistory(
                {
                    ...userRole,
                    id: params.productId,
                    startDate: filter.startDate,
                    endDate: filter.endDate,
                    page: initialPage,
                    limit: initialLimit
                }
            ));
        }
    }, [dispatch, filter, initialLimit, initialPage, params.productId, userRole])

    useEffect(() => {
        if (params.productId && (!filter.startDate || !filter.endDate)) {
            dispatch(fetchProductHistory(
                {
                    ...userRole,
                    id: params.productId,
                    page: initialPage,
                    limit: initialLimit
                }
            ));
        }
    }, [dispatch, filter, params.productId, userRole, initialPage, initialLimit]);

    return (
        <>
            <SubHeader title="Product History">
                <input
                    className="form-control form-control-sm"
                    name="startDate"
                    type="date"
                    value={filter.startDate}
                    onChange={(e) => handleChange("startDate", e.target.value)}
                />
                <input
                    className="form-control form-control-sm"
                    name="endDate"
                    type="date"
                    value={filter.endDate}
                    onChange={(e) => handleChange("endDate", e.target.value)}
                />
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>

            {fetchHistoryStatus === "loading" && <p>Loading...</p>}
            {fetchHistoryStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchHistoryStatus === "success" && (
                <>
                    <Stack className="mb-5 gap-2 ms-5">
                        <div className="border border-primary rounded-3 px-2 py-1" style={{width: "fit-content"}}>
                            <p className="m-0 fs-md fw-medium">
                                <span>Order : </span>{historyPagination?.totalOrders || 0}</p>
                        </div>
                        <div className="border border-info rounded-3 px-2 py-1" style={{width: "fit-content"}}>
                            <p className="m-0 fs-md fw-medium">
                                <span>Vendor Purchase : </span>{historyPagination?.totalVendorPurchase || 0}</p>
                        </div>
                        <div className="border border-secondary rounded-3 px-2 py-1" style={{width: "fit-content"}}>
                            <p className="m-0 fs-md fw-medium">
                                <span>Internal Share : </span>{historyPagination?.totalInternalShare || 0}</p>
                        </div>
                    </Stack>
                    <div className='table-responsive'>
                        <table className="table table-sm fs-md mobile-responsive">
                            <thead>
                            <tr>
                                <th>Type of consuming</th>
                                <th>Quantity</th>
                                <th>Order Time</th>
                                <th>View Order</th>
                            </tr>
                            </thead>
                            <tbody>
                            {items?.map((item, index) => {
                                let linkPath = '';
                                if (item.useType === ProductScope.InternalShare) {
                                    linkPath = `/internalOrder/${item.orderId}`;
                                } else if (item.useType === ProductScope.Vendor) {
                                    linkPath = `/purchase/${item.orderId}`;
                                } else if (item.useType === ProductScope.Order) {
                                    linkPath = `/order/${item.orderId}`;
                                }

                                return (
                                    <tr key={index}>
                                        <td>{item.useType}</td>
                                        <td>{item.quantity}</td>
                                        <td>{moment(item.orderTime).tz(timezone).format('MMM DD, YYYY, hh:mm A')}</td>
                                        <td>
                                            <Link
                                                to={linkPath}
                                                state={{from: `/product/${params.productId}/history`}}
                                            >
                                                View Details
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
                    {historyPagination && <Pagination data={historyPagination}/>}
                </>
            )}
        </>
    )
}

export default ProductHistory;